import React, { useEffect, useState } from 'react';
import './TaskList.css';
import API_BASE_URL from '../../config';

function TaskList({ relatedId, relatedType, onTaskClick }) {
  const [tasks, setTasks] = useState([]);

  const formatDateOnly = (value) => {
    if (!value) return '—';

    const dateString = String(value).split('T')[0];
    const [year, month, day] = dateString.split('-');

    if (!year || !month || !day) return '—';

    return `${month}/${day}/${year}`;
  };

  const formatTimeOnly = (value) => {
    if (!value) return '—';

    const timeString = String(value).trim();

    const [hourPart, minutePart] = timeString.split(':');

    const hourNumber = Number(hourPart);
    const minuteNumber = Number(minutePart);

    if (Number.isNaN(hourNumber) || Number.isNaN(minuteNumber)) {
      return '—';
    }

    const suffix = hourNumber >= 12 ? 'PM' : 'AM';
    const displayHour = hourNumber % 12 || 12;
    const displayMinute = String(minuteNumber).padStart(2, '0');

    return `${displayHour}:${displayMinute} ${suffix}`;
  };

  const formatTimeRange = (task) => {
    const start = formatTimeOnly(task.start_time);
    const end = formatTimeOnly(task.end_time);

    if (start === '—' && end === '—') return '—';
    if (start !== '—' && end !== '—') return `${start} - ${end}`;
    return start !== '—' ? start : end;
  };

  const fetchTasks = () => {
    const token = localStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };

    fetch(`${API_BASE_URL}/api/tasks?relatedType=${relatedType}&relatedId=${relatedId}`, { headers })
      .then((res) => res.json())
      .then(setTasks)
      .catch((err) => console.error('Error fetching tasks:', err));
  };

  useEffect(() => {
    fetchTasks();
  }, [relatedId, relatedType]);

  return (
    <table className="sales-table task-sales-table">
      <thead>
        <tr>
          <th>Task Date</th>
          <th>Time</th>
          <th>Type</th>
          <th>Title</th>
          <th>Note</th>
        </tr>
      </thead>

      <tbody>
        {tasks.length === 0 ? (
          <tr>
            <td colSpan="5" className="sales-empty-cell">
              No tasks found.
            </td>
          </tr>
        ) : (
          tasks.map((task) => (
            <tr
              key={task.id}
              className={`sales-click-row ${onTaskClick ? 'task-click-row' : ''}`}
              onClick={() => onTaskClick && onTaskClick(task)}
            >
              <td>{formatDateOnly(task.due_date)}</td>
              <td>{formatTimeRange(task)}</td>
              <td>{task.type || '—'}</td>
              <td>
                <div className="sales-primary-cell">
                  <div className="sales-name">{task.title || '—'}</div>
                </div>
              </td>
              <td>
                <div className="sales-secondary task-note-cell">
                  {task.note || '—'}
                </div>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  );
}

export default TaskList;